import {
  axiosInstance,
  axiosInstanceWithIdentityProviderHeader,
} from "./axios/axiosInstance";
import { LICENSE_TYPES } from "../src/interfaces/IUserInterface";
import { ApiKeyResponse } from "../src/interfaces/ApiKeyResponse";
import { environment_conf as conf } from "./environment";
import { AiModel } from "./interfaces/AiModel";

export const getDomainHint = (emailAddress, callback, err) => {
  axiosInstanceWithIdentityProviderHeader
    .get(conf.base_app_domain + `/domainHints/get?email=${emailAddress}`)
    .then((resp) => callback(resp))
    .catch((error) => err(error));
};

export const getLicense = async (
  accessKey,
  setState,
  getTerms,
  setLicenseType,
  setAdmin,
  setSubscriptionOwner,
  environment_conf
) => {
  var baseDomain = environment_conf.base_app_domain;

  const config = {
    headers: { Authorization: "Bearer " + accessKey },
  };

  setState({ licenseFetchingStatus: "fetching" });

  axiosInstanceWithIdentityProviderHeader
    .get(baseDomain + "/seats/getSeat", config)
    .then(function (response) {
      setState({ licenseFetchingStatus: "fetched" });

      if (!response.data || response.data.status != "Subscribed") {
        setLicenseType(LICENSE_TYPES.ENTERPRISE);
        return;
      }

      var plan = response.data.planId.toLowerCase();
      switch (plan) {
        case "basic":
          setLicenseType(LICENSE_TYPES.BASIC);
          setSubscriptionOwner(response.data.subscriptionOwner);
          setAdmin(false);
          break;
        case "premium":
          setLicenseType(LICENSE_TYPES.PREMIUM);
          setSubscriptionOwner(response.data.subscriptionOwner);
          setAdmin(false);
          break;
        case "individual":
          setLicenseType(LICENSE_TYPES.INDIVIDUAL);
          setSubscriptionOwner(response.data.subscriptionOwner);
          setAdmin(false);
          break;
        case "admin":
          setLicenseType(LICENSE_TYPES.BASIC);
          setSubscriptionOwner(response.data.subscriptionOwner);
          setAdmin(true);
          break;
        default:
          break;
      }

      getTerms();
    })
    .catch(function () {
      setState({ licenseFetchingStatus: "error" });
    });
};

export const updateUserAiSetting = async (
  tokenKey: string,
  aiProvider: string,
  aiModel: string,
  apiKey: string
) => {
  var baseDomain = conf.base_app_domain;

  const config = {
    headers: { Authorization: "Bearer " + tokenKey },
  };

  const { status } = await axiosInstanceWithIdentityProviderHeader.post(
    baseDomain + "/Account/Update_AiSetting",
    { aiProvider, aiModel, apiKey },
    config
  );
  if (status) {
    return true;
  } else {
    return false;
  }
};

export const getUserAiSetting = async (tokenKey: string) => {
  var baseDomain = conf.base_app_domain;

  const config = {
    headers: { Authorization: "Bearer " + tokenKey },
  };

  const { status, data } = await axiosInstanceWithIdentityProviderHeader.get(
    baseDomain + "/Account/Get_AiSetting",
    config
  );
  if (status) {
    return data;
  } else {
    return null;
  }
};

export const getUsage = async (userId: number) => {
  const baseDomain = conf.base_app_domain;

  try {
    const response = await axiosInstanceWithIdentityProviderHeader.get(
      `${baseDomain}/usage/GetRemainingCredits`,
      {
        params: {
          UserId: userId,
        },
      }
    );

    const { status, data } = response;

    if (status === 200) {
      // Check for success status
      return data;
    } else {
      return null;
    }
  } catch (error) {
    console.error("Error fetching usage:", error);
    return null;
  }
};

export const getAvailableProvidersAsync = async (userId: string) => {
  const baseDomain = conf.base_app_domain;

  try {
    const response = await axiosInstanceWithIdentityProviderHeader.get(
      `${baseDomain}/AiProviders/GetUserProviders`,
      {
        params: {
          userId: userId,
        },
      }
    );

    const { status, data } = response;

    if (status === 200) {
      return data;
    } else {
      return null;
    }
  } catch (error) {
    console.error("Error fetching API keys:", error);
    return null;
  }
};

export const deleteNamespace = async () => {
  const baseDomain = conf.base_llm_domain;
  try {
    const response = await axiosInstance.post(`${baseDomain}/delete`);
  } catch (error) {
    console.error("Error deleting namespace:", error);
  }
};

export const getNonEmbeddingAiModels = async (): Promise<AiModel[]> => {
  const baseDomain = conf.base_app_domain;

  try {
    const response = await axiosInstanceWithIdentityProviderHeader.get(
      `${baseDomain}/AiModels/GetNonEmbeddingModels`
    );

    const { status, data } = response;

    if (status === 200) {
      return data;
    } else {
      return null;
    }
  } catch (error) {
    console.error("Error fetching non-embedding models:", error);
    return null;
  }
};

export const getUser = async (username) => {
  const baseDomain = conf.base_app_domain;

  try {
    const response = await axiosInstanceWithIdentityProviderHeader.get(
      `${baseDomain}/users/GetUser`,
      {
        params: {
          username: username,
        },
      }
    );

    const { status, data } = response;

    if (status === 200) {
      // Check for success status
      return data;
    } else {
      return null;
    }
  } catch (error) {
    console.error("Error fetching user data:", error);
    return null;
  }
};

export const getAllAiProviders = async () => {
  const baseDomain = conf.base_app_domain;

  try {
    const response = await axiosInstanceWithIdentityProviderHeader.get(
      `${baseDomain}/AiProviders/GetAllAiProviders`
    );

    const { status, data } = response;

    if (status === 200) {
      // Check for success status
      return data;
    } else {
      return null;
    }
  } catch (error) {
    console.error("Error fetching user data:", error);
    return null;
  }
};

export const getUserApiKeyByProvider = async (
  userId: number,
  providerId: number
): Promise<ApiKeyResponse | null> => {
  const baseDomain = conf.base_app_domain;

  try {
    const response = await axiosInstanceWithIdentityProviderHeader.get(
      `${baseDomain}/user/${userId}/provider/${providerId}/`
    );

    const { status, data } = response;

    if (status === 200) {
      return data;
    } else {
      return null;
    }
  } catch (error) {
    console.error("Error fetching API key for provider:", error);
    return null;
  }
};
